import { PxtraApiClientLegacy } from '@pxtra-client-lib-legacy';
import React, { useMemo } from 'react';
import { env } from '../lib/env';

const apiClientContext = React.createContext<PxtraApiClientLegacy | null>(null);

export const PxtraApiClientProvider = ({ children }: React.PropsWithChildren) => {
  const apiClient = useMemo(
    () =>
      new PxtraApiClientLegacy({
        config: {
          BASE: env('API_BASE_URL')
        }
      }),
    []
  );

  return <apiClientContext.Provider value={apiClient}>{children}</apiClientContext.Provider>;
};

export const usePxtraApiClient = () => {
  const apiClient = React.useContext(apiClientContext);
  if (!apiClient) {
    throw new Error('No Client');
  }
  return apiClient;
};
